import { render, staticRenderFns } from "./beacon.vue?vue&type=template&id=05133916&scoped=true&"
import script from "./beacon.vue?vue&type=script&lang=js&"
export * from "./beacon.vue?vue&type=script&lang=js&"
import style0 from "./beacon.vue?vue&type=style&index=0&id=05133916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05133916",
  null
  
)

export default component.exports